define('Facets.ItemCell.View.Extension', [
  'Facets.ItemCell.View',

  'Backbone',
  'jQuery',
  'Utils',
  'underscore'
], function (
  FacetsItemCellView,

  Backbone,
  jQuery,
  Utils,
  _
) {
  'use strict';

  _.extend(FacetsItemCellView.prototype, {
    getContext: _.wrap(FacetsItemCellView.prototype.getContext, function (fn) {
      var context = fn.apply(this, _.toArray(arguments).slice(1));

      var stockInfo = this.model.getStockInfo();
      var stock = stockInfo.stock;

      // Configuration inventory display settings
      var stockConfig = SC.CONFIGURATION.inventoryDisplay;
      var lowStockThreshold = stockConfig.lowStockThreshold;
      var lowStockMsg = stockConfig.lowStockMessage;
      var inStockMsg = stockConfig.inStockMessageForRegularItems;
      var backorderMsg = stockConfig.backorderMessageForRegularItems;

      // Item stock status
      var isBackOrderable = this.model.get('isbackorderable');
      var isOutOfStock = stock == 0;
      var isBackOrder = isOutOfStock && isBackOrderable;
      var isInStock = stock > 0;
      var isLowStock = isInStock && stock < lowStockThreshold;

      var stockMessage = inStockMsg;
      var stockClass = 'product-line-stock-msg-in';

      if (isLowStock) {
        stockMessage = lowStockMsg;
        stockClass = 'product-line-stock-msg-low';
      }

      if (isOutOfStock) {
        stockMessage = 'Out of Stock';
        stockClass = 'product-line-stock-msg-out';
      }

      if (isBackOrder) {
        stockMessage = backorderMsg;
        stockClass = 'product-line-stock-msg-low';
      }

      // Set stockDescription to trigger displaying stockDescriptionView
      // on facetsItemsCellView
      this.model.set('_stockDescription', stockMessage);
      this.model.set('_stockDescriptionClass', stockClass);
      this.model.set('_showStockDescription', true);

      return context;
    })
  });
});
